import Badge from '@klv/atoms/badge';
import Icon from '@klv/atoms/icon';

import { generateClassName } from '@klv/shared/utils/functions';

import * as styles from './styles/universalMenuItem.module.scss';

import type { IUniversalMenuItem } from './types';

export const UniversalMenuItem = <T extends React.ElementType = 'a'>({
  as,
  badge = {
    color: 'charcoal',
    text: '',
  },
  callToAction,
  children,
  childItems,
  className,
  description,
  featured = false,
  href,
  iconName,
  image,
  label,
  locale,
  order,
  position,
  trailingMark = false,
  type,
  width,
  ...props
}:
IUniversalMenuItem<T>
& Omit<React.ComponentPropsWithoutRef<T>, keyof IUniversalMenuItem<T>>) => {
  const Component = as || 'a';
  const hasImage = image && image?.sourceUrl;

  return (
    <Component
      className={generateClassName([
        className,
        styles.universalMenuItem,
        featured && styles.featured,
        (hasImage) && styles.hasImage,
      ])}
      href={href}
      {...props}
    >
      {children ? children : (
        <>
          {hasImage && (
            <div className={styles.imageContainer}>
              <img alt={image?.altText} className={styles.image} loading='lazy' src={image?.sourceUrl} />
            </div>
          )}
          {iconName && (
            <Icon className={styles.icon} color='currentColor' iconName={iconName} size={1.4} />
          )}
          {(label || children || trailingMark) && (
            <>
              {label ? label : null}
              {trailingMark && (
                <span className={styles.trailingMark} />
              )}
            </>
          )}
          {badge?.text && badge?.color && (
            <Badge color={badge.color} text={badge.text} />
          )}
          {description && (
            <span className={styles.description} dangerouslySetInnerHTML={{ __html: description }} />
          )}
        </>
      )}
    </Component>
  );
};
